(function () {
    'use strict';

    angular
        .module('app.shared')
        .filter('toPar', toParFilterFactory);

    toParFilterFactory.$inject = [];
    function toParFilterFactory() {
        return function toParFilter(input) {
            return typeof (input) !== 'number' ? null :
                input === 0 ? 'E' :
                    (input > 0 ? '+' : '') + input;
        }
    }
})();